import { Element, useNode } from "@craftjs/core";
import * as React from "react";

import TopLevelFloatingOptions from "@/components/editor/block-outline/floating-options/top-level-floating-component";
import RichTextEditor from "@/components/editor/primitives/rich-text";
import {
  BlockBackgroundColorWrapper,
  BlockMaxWidthWrapper,
  BlockPaddingWrapper,
} from "@/components/editor/shared/block-wrapper";

export type RichTextSectionProps = {
  text: string;
};

export default function RichTextSection({ text }: RichTextSectionProps) {
  const {
    id,
    connectors: { connect },
  } = useNode();

  return (
    <BlockBackgroundColorWrapper
      ref={connect}
      id={id}
      data-testid="text-editor-wrapper"
    >
      <BlockPaddingWrapper>
        <BlockMaxWidthWrapper data-testid="rich-text-section">
          <Element id="rich-text-section" is={RichTextEditor} text={text} />
        </BlockMaxWidthWrapper>
      </BlockPaddingWrapper>
    </BlockBackgroundColorWrapper>
  );
}

RichTextSection.craft = {
  custom: {
    displayName: "Rich text section",
  },
  related: {
    leftOutlineOptions: TopLevelFloatingOptions,
  },
};
